import { groupBy } from 'lodash';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const fetchEventTime = /* @__PURE__ */ __name(async (blockNumber, provider) => {
  const msecToSec = 1e3;
  const eventTimestamp = (await provider.getBlock(blockNumber)).timestamp * msecToSec;
  return eventTimestamp;
}, "fetchEventTime");
const getHolderOwner = /* @__PURE__ */ __name((events) => {
  let owner = "";
  let holder = "";
  for (const event of events) {
    owner = event.owner || owner;
    holder = event.holder || holder;
  }
  return { owner, holder };
}, "getHolderOwner");
const mergeTransfersV4 = /* @__PURE__ */ __name((transferEvents) => {
  const groupedEventsDict = groupBy(
    transferEvents,
    "transactionHash"
  );
  const transactionHashValues = Object.values(groupedEventsDict);
  const mergedTransaction = transactionHashValues.flatMap((groupedEvents) => {
    if (groupedEvents.length === 1) return groupedEvents;
    if (groupedEvents.length === 2) {
      const type = "TRANSFER_OWNERS";
      const base = groupedEvents[0];
      const { owner, holder } = getHolderOwner(groupedEvents);
      return [{ ...base, type, owner, holder }];
    }
    if (groupedEvents.length === 3) {
      const base = groupedEvents[0];
      const type = "INITIAL";
      const { owner, holder } = getHolderOwner(groupedEvents);
      const found = groupedEvents.find((x) => {
        return x.type === "INITIAL" || x.type === "SURRENDER_ACCEPTED";
      });
      return [{ ...base, owner, holder, type: found?.type || type }];
    }
    throw new Error("Invalid hash, update your configuration");
  });
  return mergedTransaction;
}, "mergeTransfersV4");
const mergeTransfersV5 = /* @__PURE__ */ __name((transferEvents) => {
  const groupedEventsDict = groupBy(
    transferEvents,
    "transactionHash"
  );
  const transactionHashValues = Object.values(groupedEventsDict);
  const mergedTransaction = transactionHashValues.flatMap((groupedEvents) => {
    if (groupedEvents.length === 1) return groupedEvents;
    if (groupedEvents.length > 1) {
      const { owner, holder } = getHolderOwner(groupedEvents);
      const type = identifyEventTypeFromLogs(groupedEvents);
      const base = groupedEvents.find((event) => event.type === type) ?? groupedEvents[0];
      return [{ ...base, owner, holder, type }];
    }
    throw new Error("Invalid hash, update your configuration");
  });
  return mergedTransaction;
}, "mergeTransfersV5");
const identifyEventTypeFromLogs = /* @__PURE__ */ __name((groupedEvents) => {
  for (const event of groupedEvents) {
    if ([
      "INITIAL",
      "RETURNED_TO_ISSUER",
      "RETURN_TO_ISSUER_ACCEPTED",
      "RETURN_TO_ISSUER_REJECTED"
    ].includes(event.type) || event.type.startsWith("REJECT_")) {
      return event.type;
    }
  }
  const isTransferHolder = groupedEvents.some((event) => event.type === "TRANSFER_HOLDER");
  const isTransferBeneficiary = groupedEvents.some(
    (event) => event.type === "TRANSFER_BENEFICIARY"
  );
  if (isTransferHolder && isTransferBeneficiary) {
    return "TRANSFER_OWNERS";
  } else if (isTransferHolder) {
    return "TRANSFER_HOLDER";
  } else if (isTransferBeneficiary) {
    return "TRANSFER_BENEFICIARY";
  }
  throw new Error("Unable to identify event type");
}, "identifyEventTypeFromLogs");
const sortLogChain = /* @__PURE__ */ __name((logChain) => {
  return logChain.sort((a, b) => {
    return a.blockNumber - b.blockNumber;
  });
}, "sortLogChain");

export { fetchEventTime, mergeTransfersV4, mergeTransfersV5, sortLogChain };
